import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Style = {
    padding: '10px',
    backgroundColor: '#ececec',
    borderRadius: '2px' ,
    marginBottom: '4px'
};

const CheckInput = (props) => {

    return (<div style={props.style || Style}>
        <div className="clearfix">
            {_.isString(props.title) ? <b className="pull-left">{props.title}</b> : props.title}
            <label className="switch switch-3d switch-primary switch-sm pull-right" >
                <input type="checkbox" className="switch-input" checked={props.checked} onChange={props.onChange} />
                <span className="switch-label"></span>
                <span className="switch-handle"></span>
            </label>
        </div>
        {props.hint && <p className="help-block">{props.hint}</p>}
    </div>);

};

CheckInput.propTypes = {
    style: PropTypes.object,
    title: PropTypes.any,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    hint: PropTypes.string
};

export default CheckInput;


// WEBPACK FOOTER //
// ./src/components/CheckInput/CheckInput.js